import Store, { AppState } from "./store";
import Mutator from "./actions";

const configureState = (initialState: AppState) => {
  const store = new Store(initialState);
  const mutator = new Mutator({ store });
  return {
    store,
    mutator,
  };
};

export default configureState;
